module.exports = __webpack_public_path__ + "static/img/shop7.beb2500.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop7.png
// module id = 3Jwn
// module chunks = 2